import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SessionCleanupService } from 'src/app/services/session-cleanup.service';

export const authGuard: CanActivateFn = () => {
  const sessionCleanup = inject(SessionCleanupService);

  const token = localStorage.getItem('token');
  const accessToken = JSON.parse(localStorage.getItem('tokenaccess') || '{}');

  if (
    token &&
    Number(accessToken['branchId']) > 0 &&
    Number(accessToken['financeId']) > 0 &&
    Number(accessToken['companyId']) > 0
  ) {
    return true;
  }

  sessionCleanup.promptSessionExpiredAndLogout(5);

  return false;
};
